/**
 * @title History Page
 * @description Contains a list of historic tradeins
 */
import * as React from "react";
import {FC, useEffect} from "react";
import {useHistoryPageTradeInsQuery} from "../../../Queries";
import {Box} from "@mui/material";
import {ReturnsPagePath} from "../returns/ReturnsPage";
import {PrivateRenderer} from "../PrivateRenderer";
import {StyledButton, StyledTypography} from "../../../providers/layout/LayoutProvider";
import {makeStyles} from "@mui/styles";
import {useRecoilValue} from "recoil";
import {LocalizationsAtom} from "../../../providers/localization/LocalizationProvider";
import {HistoryItem} from "./HistoryItem";
import {useNavigate} from "react-router-dom";
import {Analytics, AnalyticsEvent} from "../../../analytics/Analytics";
import {Progress} from "../../../components/Progress";

export const HistoryPagePath = () => {
   return ReturnsPagePath() + "/history";
}

export const HistoryPage: FC<any> = () => {
   const {data} = useHistoryPageTradeInsQuery()
   const classes = useStyles();
   const localizations = useRecoilValue(LocalizationsAtom);
   const navigate = useNavigate();

   useEffect(() => {
      Analytics.event(AnalyticsEvent.trackViewHistory);
   }, [])

   if (!data?.ConsumerTradeIns) {
      return <Progress/>
   }

   const onBackToFront = async () => {
      navigate(ReturnsPagePath());
   }

   return <PrivateRenderer hideSteppers={true}>
      <Box className={classes.page}>
         <Box className={classes.pageTitle}>
            <StyledTypography type={"main"} variant={"h1"}>
               {localizations.historicPageTitle}
            </StyledTypography>
         </Box>
         {data?.ConsumerTradeIns?.map(tradeIn => {
            return <HistoryItem key={'history_' + tradeIn?._id} item={tradeIn!}/>
         })}

         <StyledButton invert={true} styletype={"main"} style={{marginTop: '20px', padding: '5px 40px 5px 40px'}}
                       onClick={onBackToFront}>
            {localizations.consumerAlmostTHereBackToStart}
         </StyledButton>

      </Box>
   </PrivateRenderer>
}


const useStyles = makeStyles({
   page: {
      display: 'flex',
      width: '100%',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'start'
   },
   pageTitle: {
      padding: '50px'
   }
});
